import { render, staticRenderFns } from "./AlertModal.vue?vue&type=template&id=d166b106&scoped=true"
import script from "./AlertModal.vue?vue&type=script&lang=ts"
export * from "./AlertModal.vue?vue&type=script&lang=ts"
import style0 from "./AlertModal.vue?vue&type=style&index=0&id=d166b106&prod&lang=scss"
import style1 from "./AlertModal.vue?vue&type=style&index=1&id=d166b106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d166b106",
  null
  
)

export default component.exports